import { tran } from '@/utils/assist'
import { defineComponent, onMounted, reactive, watch } from '@vue/composition-api'
import _ from 'lodash'
import './index.scss'
import OptionSettings from '../../../SurveyDetail/compontents/optionSettings'
import { LAST_TOPIC_WORD, NEXT_TOPIC_WORD } from '../../config'
const PageEdit = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['changeTopicContent'],
  setup(props, context) {
    const { emit } = context
    const state = reactive({
      editItem: _.cloneDeep(props.item) //编辑数据源
    })
    watch(
      () => state.editItem,
      (val) => {
        emit('changeTopicContent', val)
      },
      {
        deep: true
      }
    )
    // onMounted(()=>{
    //   state.editItem = {}
    // })
    return () => {
      return (
        <div class="topic-edit-content page-topic-edit-content">
          {/* <div class='topic-edit-content-item'>
          <el-checkbox value={state.editItem.topicSetting.isRollback} onInput={value => state.editItem.topicSetting.isRollback = value}>{tran('survy.aloback')}</el-checkbox>
          <el-checkbox value={state.editItem.topicSetting.isAllowSubmit} onInput={value => state.editItem.topicSetting.isAllowSubmit = value}>{tran('survy.aloend')}</el-checkbox>
        </div >
        <div class='topic-edit-content-item'>
          <div class='page-edit-row'>
            <div class='page-edit-row-item'>
              <span>{tran('survy.beftextt')}</span>
              <el-input size='small' value={state.editItem.topicSetting.lastPageText} onInput={value => state.editItem.topicSetting.lastPageText = value} placeholder={tran('survy.plccontent')}></el-input>
            </div>
            <div class='page-edit-row-item'>
              <span>{tran('survy.afttext')}</span>
              <el-input size='small' value={state.editItem.topicSetting.nextPageText} onInput={value => state.editItem.topicSetting.nextPageText = value} placeholder={tran('survy.plccontent')}></el-input>
            </div>
          </div>
        </div> */}
          {state.editItem.hasOwnProperty('isShowLastPage') &&
            state.editItem.isShowLastPage &&
            !state.editItem.isFirstPage && (
              <el-button onClick={() => {}} size="small" type="success">
                <span
                  domPropsInnerHTML={
                    state.editItem.topicSetting.lastPageText || LAST_TOPIC_WORD
                  }></span>
              </el-button>
            )}
          {!state.editItem.hasOwnProperty('isShowLastPage') &&
            state.editItem.topicSetting.isRollback &&
            !state.editItem.isFirstPage && (
              <el-button onClick={() => {}} size="small" type="success">
                <span
                  domPropsInnerHTML={
                    state.editItem.topicSetting.lastPageText || LAST_TOPIC_WORD
                  }></span>
              </el-button>
            )}
          <el-button onClick={() => {}} size="small" type="success">
            <span
              domPropsInnerHTML={
                state.editItem.topicSetting.nextPageText || NEXT_TOPIC_WORD
              }></span>
          </el-button>
          {state.editItem.topicSetting.isAllowSubmit && (
            <el-button onClick={() => {}} size="small" type="success">
              <span>{state.editItem.endBtnsWord || tran('survy.push')}</span>
            </el-button>
          )}
          <Portal to="survey-option-settings">
            <OptionSettings
              type={props.item.topicType}
              isRollback={state.editItem.topicSetting.isRollback}
              isAllowSubmit={state.editItem.topicSetting.isAllowSubmit}
              lastPageText={state.editItem.topicSetting.lastPageText}
              nextPageText={state.editItem.topicSetting.nextPageText}
              onChangeIsRollback={(value) => {
                state.editItem.topicSetting.isRollback = value
              }}
              onChangeIsAllowSubmit={(value) => {
                state.editItem.topicSetting.isAllowSubmit = value
              }}
              onChangeLastPageText={(value) => {
                state.editItem.topicSetting.lastPageText = value
              }}
              onChangeNextPageText={(value) => {
                state.editItem.topicSetting.nextPageText = value
              }}
            />
          </Portal>
        </div>
      )
    }
  }
})
export default PageEdit
